import { render, staticRenderFns } from "./ListingCard.vue?vue&type=template&id=f23196c0&scoped=true"
import script from "./ListingCard.vue?vue&type=script&lang=ts"
export * from "./ListingCard.vue?vue&type=script&lang=ts"
import style0 from "./ListingCard.vue?vue&type=style&index=0&id=f23196c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23196c0",
  null
  
)

export default component.exports